import React from 'react'
import styles from './FriendRequestsList.scss'
import {Card} from 'common/styleguide/Card'
import {ProfileImg} from 'common/ProfileImg'
import {urls} from 'lib/urls'
import PropTypes from 'prop-types'

export class FriendRequestsList extends React.PureComponent {
  static propTypes = {
    onConfirmClicked: PropTypes.func.isRequired,
    onIgnoreClicked: PropTypes.func.isRequired,
    onUnfriendClicked: PropTypes.func.isRequired
  }

  render () {
    const {
      pendingIncomingFriends,
      pendingOutgoingFriends,
      onConfirmClicked,
      onIgnoreClicked,
      onUnfriendClicked
    } = this.props
    return (
      <div>
        <h2 data-heading-alt>Pending Friends</h2>
        <Card className={styles.pendingFriendsCard}>
          {!pendingIncomingFriends.isEmpty() && pendingIncomingFriends.toIndexedSeq().map((user) => {
            return <div key={user.id} className={styles.request}>
              <a href={urls.users.show(user.id)}>
                <ProfileImg user={user} />
              </a>
              <div className={styles.user}>
                <div className={styles.name}>{user.name}</div>
                <div className={styles.buttons}>
                  <a onClick={() => onConfirmClicked(user.id)}>Accept</a>
                  <a onClick={() => onIgnoreClicked(user.id)} className={styles.right}>Ignore</a>
                </div>
              </div>
            </div>
          })}

          {!pendingOutgoingFriends.isEmpty() && pendingOutgoingFriends.toIndexedSeq().map((user) => {
            return <div key={user.id} className={styles.request}>
              <a href={urls.users.show(user.id)}>
                <ProfileImg user={user} />
              </a>
              <div className={styles.user}>
                <div className={styles.name}>{user.name}</div>
                <div className={styles.buttons}>
                  <a onClick={() => onUnfriendClicked(user.id)}>Remove</a>
                </div>
              </div>
            </div>
          })}
        </Card>
      </div>
    )
  }
}
